import { useCallback, useEffect, useMemo, useState } from 'react';
import { getReadingTabs, READING_TABS_STORAGE_KEY, type ReadingTabEntry } from '@/utils/reading-tabs';

export function useReadingTabs(): ReadingTabEntry[] {
    const [version, setVersion] = useState(0);

    const bump = useCallback(() => setVersion((v) => v + 1), []);

    useEffect(() => {
        const onStorage = (e: StorageEvent) => {
            if (e.key === READING_TABS_STORAGE_KEY || e.key == null) bump();
        };
        window.addEventListener('reading-tabs-changed', bump);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('reading-tabs-changed', bump);
            window.removeEventListener('storage', onStorage);
        };
    }, [bump]);

    return useMemo(() => getReadingTabs(), [version]);
}
